import React from 'react'

export interface IconProps {
  width?: number
  height?: number
  testId?: string
  color?: string
  size?: number
  style?: React.CSSProperties
  className?: string
  onClick?: () => void
}

export const Close = ({ testId, className, style, color = '#AFAFAF', onClick, width = 10, height = 12 }: IconProps) => (
  <svg
    className={className}
    data-ig-id={testId}
    width={width}
    height={height}
    viewBox={`0 0 10 12`}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    onClick={onClick}
    style={style}
  >
    <path d='M9 1.44067L1.22605 10.0142' stroke={color} strokeWidth='2' strokeLinecap='round' />
    <path d='M9 10.2632L1.22605 1.68962' stroke={color} strokeWidth='2' strokeLinecap='round' />
  </svg>
)

export default Close
